import React from 'react';

function DemoLogin({ onDemoLogin }) {
  const demoUsers = [
    {
      name: 'João Silva',
      email: 'joao@demo.com',
      isPremium: false
    },
    {
      name: 'Maria Santos',
      email: 'maria@demo.com',
      isPremium: true
    }
  ];

  const handleDemoLogin = (demoUser) => {
    // Simular token e dados do usuário
    const userData = {
      id: Math.floor(Math.random() * 1000),
      ...demoUser,
      verified: true
    };
    
    const token = 'demo_token_' + Date.now();
    
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    
    onDemoLogin(userData);
  };

  return (
    <div className="demo-login">
      <h3>🚀 Login Demo</h3>
      <p>Teste o sistema sem cadastro:</p>
      
      <div className="demo-users">
        {demoUsers.map((user, index) => (
          <button
            key={index}
            className={`demo-btn ${user.isPremium ? 'premium' : ''}`}
            onClick={() => handleDemoLogin(user)}
          >
            <div className="demo-avatar">
              {user.name.charAt(0)}
            </div>
            <div className="demo-info">
              <strong>{user.name}</strong>
              <small>{user.email}</small>
              {user.isPremium && <span className="demo-premium">Premium</span>}
            </div>
          </button>
        ))}
      </div>
      
      <small>* Login demo - dados não são salvos</small>
    </div>
  );
}

export default DemoLogin;